import React, { createContext, useState } from 'react'

import { registerPopupFunction } from '../util/globalFunction'

export const PopupContext = createContext()

const PopupProvider = ({ children }) => {
    const [popupInfo, setPopupInfo] = useState({
        open: false,
        popupType: null,
        resolve: null,
        title: null,
        message: null,
        defaultValue: null,
        returnFunction: null,
    })

    const close = () => {
        setPopupInfo({ open: false })
    }

    const popup = info =>
        new Promise((resolve, reject) => setPopupInfo({ open: true, resolve, ...info }))

    registerPopupFunction(popup)

    return (
        <PopupContext.Provider value={{ popupInfo, popup, close }}>
            {children}
        </PopupContext.Provider>
    )
}

export default PopupProvider
